// index.tsx
// TextWithTooltip component for displaying text with a tooltip on hover.
// Used to provide additional context or full text for truncated or important values.

import { Tooltip } from "@/vendor/Forge/dist";

/**
 * Props for the TextWithTooltip component
 * @property id - Unique identifier for the tooltip
 * @property text - The text to display
 * @property textTooltip - The tooltip text to show on hover
 */
interface Props {
  id: string;
  text: string;
  textTooltip: string;
}

/**
 * TextWithTooltip Component
 * Displays text with a tooltip on hover. Returns null if no text is provided.
 * @param id - Unique identifier for the tooltip
 * @param text - The text to display
 * @param textTooltip - The tooltip text to show on hover
 */
const TextWithTooltip = ({ id, text, textTooltip }: Props) => {
  if (!text) return null;
  return (
    <div data-testid="wrapper-textToolTip">
      <Tooltip id={`text-tooltip-${id}`} text={textTooltip}>
        {text}
      </Tooltip>
    </div>
  );
};

export default TextWithTooltip;
